import { SkillDefinition } from "./types";
import type { CombatEvent } from "../../state/combatEvents";

/**
 * Computes the ATK buff granted by Blood Pact based on level.
 * Level 1: +3, Level 2: +4, Level 3: +5, Level 4: +6, Level 5: +7
 */
const getBloodPactAttackBuff = (level: number): number => 2 + level;

export const bloodPactSkill = {
  id: "bloodPact",
  name: "Blood Pact",
  description: "Sacrifice 3 HP to gain +3 ATK for this combat. Upgrades increase ATK gained.",
  requiresTarget: false,
  use: ({ skillLevel, applyDamageToPlayerSelf, applyAttackBuffToPlayer }) => {
    const events: CombatEvent[] = [];

    // Sacrifice 3 HP (self-damage, bypasses armor for flavor)
    const sacrificeAmount = 3;
    const selfDamage = applyDamageToPlayerSelf(sacrificeAmount);

    if (selfDamage > 0) {
      events.push({
        kind: "playerSelfDamage" as const,
        amount: selfDamage,
      });

      // Grant ATK buff based on skill level
      const atkBuff = getBloodPactAttackBuff(skillLevel);
      applyAttackBuffToPlayer(atkBuff);
    }

    return events;
  },
} satisfies SkillDefinition<"bloodPact">;
